var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FdProductTile',{attrs:{"title":"Product Tile Button","url":"https://techne.yaas.io/images/product-thumbnail-wide.png","isButton":""}})}
var staticRenderFns = []

export { render, staticRenderFns }